import React, { useEffect } from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

function ChartDatePicker (props) {
  const { isMonth, handleChange = () => {}, content } = props
  const dateCode = isMonth ? 'M' : 'd'
  const defDate = isMonth ? 6 : 7
  const limit = isMonth ? 12 : 14

  const defaultDate = [dayjs().subtract(defDate, dateCode), dayjs()]
  useEffect(() => {
    handleChange(defaultDate)
  }, [content])

  return <DatePicker.RangePicker
    allowClear={false}
    style={{ margin: '12px 0 0 auto', display: 'flex', width: 'fit-content' }}
    picker={isMonth ? 'month' : 'date'}
    defaultValue={defaultDate}
    disabledDate={(date, { from }) => (
      dayjs(date) > dayjs() ||
      (from && dayjs(date) > dayjs(from).add(limit, dateCode)) ||
      (from && dayjs(date) < dayjs(from).subtract(limit, dateCode))
    )}
    onChange={handleChange}
  />
}

export default ChartDatePicker
